<template>
  <v-container>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <v-row class="mt-10">
      <v-col class="text-tcdc-green text-uppercase bold header pt-0">tcdc bangkok</v-col>
    </v-row>
    <v-row id="news-list">
      <v-col class="text-tcdc-green text-uppercase bold header">{{$t('about.news')}}</v-col>
    </v-row>
    <v-row>
      <template v-for="(item,i) of news">
        <v-col :key="i" cols="12" md="6">
          <NewsCard
                  :border="parseInt(item) <= 4-2"
                  :image="item.image_path"
                  :title="item[`title_${lang}`]"
                  :description="item[`intro_${lang}`]"
                  :date="item.publish_date | moment('DD MMM')"
                  :viewer="item.viewer"
                  class="cursor-pointer"
                  @click.native="newsHandler(item.news_id)"
          />
        </v-col>
      </template>
    </v-row>
    <div class="d-flex justify-end">
      <v-pagination
              v-model="newsPage.current_page"
              :length="newsPage.last_page"
              total-visible="7"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              color="#2e8037"
              @input="(event) => {changePage(event); $vuetify.goTo('#news-list');}"
      ></v-pagination>
    </div>
  </v-container>
</template>

<script>
import NewsCard from "../../components/cards/NewsCard";
import { mapState } from "vuex";

export default {
  components: {
    NewsCard
  },
  created() {
    this.items[0].text = this.branchName;
    // console.log(this.news)
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      branchId: state => state.Branch.branch_id,
      news: state => state.About.news.data,
      newsPage: state => state.About.news,
      lang: state => state.Branch.lang
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items[0].text = this.branchChanged;
    }
  },
  data: () => ({
    items: [
      {
        text: 'TCDC BANGKOK',
        to: "/home"
      },
      {
        text: "ABOUT",
        disabled: false,
        href: "/about/1"
      },
      {
        text: "NEWS",
        disabled: true
      }
    ]
  }),
  methods: {
    newsHandler(id) {
      this.$router.push(`/about/news/${id}`);
    },
    changePage(page) {
      this.$store.dispatch('About/getAboutNewsByPage', { id: this.branchId, page: page });
    }
  }
};
</script>

<style scoped lang="scss">

</style>
